import axios from "axios";
import { store } from "../store";
import config from "../config";
import authHeader from "./auth-header";
import unroutedEndpoint from "./unroutedEndpoint";
import { withReadablePrintError } from "./printTransportError";

const API_URL = config.API_URL;

const settingPlanhistory = () => {
  // Flask exposes no generic acs_invoice document route; subscription invoice documents are served per document.
  return unroutedEndpoint(
    "afterlogin/print/acs_invoice",
    "afterlogin/print/subscription-payment-receipt/<payment_id>"
  );
};

const clientAppointmentTabInvoice = () => {
  // Flask exposes no generic acs_invoice document route; subscription invoice documents are served per document.
  return unroutedEndpoint(
    "afterlogin/print/acs_invoice",
    "afterlogin/print/subscription-payment-receipt/<payment_id>"
  );
};

const clientdetail = (values) => {
  const clientId = values && values.client_id ? values.client_id : "";
  const action = `afterlogin/print/client-details/${clientId}`;
  return axios.post(API_URL + action, {}, { headers: authHeader() });
};

const clientDetailAppointmentPrint = (values) => {
  const clientId = values && values.client_id ? Number(values.client_id) : "";
  const action = `afterlogin/print/client-appointments/${clientId}`;
  const data = {
    start_date: values && values.start_date ? values.start_date : "",
    end_date: values && values.end_date ? values.end_date : "",
  };
  return withReadablePrintError(axios.post(API_URL + action, data, {
    headers: authHeader(),
    responseType: "blob",
  }));
};

const clientinvoicesprint = (values) => {
  const clientId = values && values.client_id ? values.client_id : "";
  const action = `afterlogin/print/client-sale-activity/${clientId}`;
  const data = {
    end_date: values && values.end_date ? values.end_date : "",
    start_date: values && values.start_date ? values.start_date : "",
  };
  return withReadablePrintError(axios.post(API_URL + action, data, {
    headers: authHeader(),
    responseType: "blob",
  }));
};

const saleVoucherPrint = () => {
  // Flask exposes no generic acs_invoice document route; subscription invoice documents are served per document.
  return unroutedEndpoint(
    "afterlogin/print/acs_invoice",
    "afterlogin/print/subscription-payment-receipt/<payment_id>"
  );
};

const calendarPrinter = () => {
  // Flask exposes no generic acs_invoice document route; subscription invoice documents are served per document.
  return unroutedEndpoint(
    "afterlogin/print/acs_invoice",
    "afterlogin/print/subscription-payment-receipt/<payment_id>"
  );
};

const calendarPrintDate = (value) => {
  if (!value) return "";
  const match = String(value).match(/^(\d{4}-\d{2}-\d{2})/);
  return match ? match[1] : value;
};

const calendarappointmentprints = (values) => {
  const range = values && values.isRangeInfo && typeof values.isRangeInfo === "object"
    ? values.isRangeInfo
    : {};
  const data = {
    start_date: calendarPrintDate(range.start_date || range.startDate || ""),
    end_date_exclusive: calendarPrintDate(range.end_date_exclusive || range.end_date || range.endDate || ""),
    status: values && values.status ? values.status : "all",
  };
  const action = "afterlogin/print/calendar";
  return axios.post(API_URL + action, data, { headers: authHeader() });
};


const reportPrinter = () => {
  // Flask replaced the Laravel beauti_report dispatcher with explicit report routes (for example afterlogin/print/sales-by-day).
  return unroutedEndpoint(
    "afterlogin/print/beauti_report",
    "afterlogin/print/sales-by-day"
  );
};

const subscriptionTandC = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  void (values && values.result ? values.result : "");
  void (values && values.apicall ? values.apicall : "");
  const action = "afterlogin/print/subscription-terms";

  const data = {
    auth_key: auth_key,
    action: action,
    pagination: false,
    invoice_for: values && values.invoice_for ? values.invoice_for : "",
    Accept: "application/pdf",
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};




const printerApiController = {
  settingPlanhistory,
  clientAppointmentTabInvoice,
  clientdetail,
  clientDetailAppointmentPrint,
  clientinvoicesprint,
  saleVoucherPrint,
  calendarPrinter,
  reportPrinter,
  subscriptionTandC,
  calendarappointmentprints
};
export default printerApiController;
